
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'
import Multiselect from 'components/Multiselect'
import * as _ from 'lodash'
import {countries as countriesList} from 'countries-list/cjs'

export class CountryMultiSelect extends React.Component {
  static propTypes = {
    countries: PropTypes.array,
    countriesLimit: PropTypes.array,
    onChange: PropTypes.func,
    values: PropTypes.array
  }

  render() {
    const {countriesLimit, countries, values} = this.props

    const limits = countriesLimit?.length ? countriesLimit : countries

    const options = _.map(limits, code => {
      return {
        value: code,
        label: countriesList[code].name
      }
    })

    return (
      <div className='country-multiselect'>
        <div className='country-multiselect_label'>Country</div>
        <Multiselect
          className='country-multiselect_select'
          addIcon='filter'
          options={options}
          values={values || []}
          onChange={this.onCountriesSelect}
        />
      </div>
    )
  }

  onCountriesSelect = values => {
    const {onChange} = this.props

    onChange && onChange(values)
  }
}

const mapStateToProps = state => {
  const currentSite = getCurrentSite(state)
  const countriesLimit = currentSite.countriesLimit || []

  return {
    countriesLimit
  }
}

export default connect(mapStateToProps)(CountryMultiSelect)



// WEBPACK FOOTER //
// ./client/components/CountryMultiSelect/index.js